module.exports = __webpack_public_path__ + "img/img_services_technical.ffa091fa.jpg";